import { Injectable } from '@angular/core';
import { marked } from 'marked';
@Injectable({ providedIn: 'root' })
export class MarkdownStripService {
  toPlainText(markdown: string): string {
    if (!markdown) return '';
    const html = marked(markdown);
    if (typeof html !== 'string') return '';
    const plain = html
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/li>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, '');
    return plain
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&nbsp;/g, ' ');
  }
}
